import { IoIosArrowBack } from "react-icons/io";
import OperationType from "../../../components/OperationType";
import { BsPersonPlusFill } from "react-icons/bs";
import "../../../styles/stores/makeTransactions/confirmProducts.css";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createTransactionUrl } from "../../../api/endpoints";
import { updateCart, clearCart } from "../../../slice/sellingCarts";
import { setUser } from "../../../slice/webStoreUserSlice";
import CountryPhoneList from "../../../components/input/InputPhoneTel";
import "react-phone-number-input/style.css";

import { ButtonLoader } from "../../../components/uxCollections/Loaders";
import { updateNotification } from "../../../slice/notificationSlice";
import CashPayment from "./paymentWindow/CashPayment";
import CardPayment from "./paymentWindow/CardPayment";
import MobilePay from "./paymentWindow/MobilePay";
import { modifyTansactionData } from "../../../tools/indexdb";
import { addToQueue } from "../../../slice/offlineQueue";
import { FaCheck } from "react-icons/fa";
import { uiAlert } from "../../../components/alerts/customAlert/uiAlert";
// this component is not in use to be deleted
const generateTransactionID = () => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = today.getFullYear();
  const dateNum = `${day}${month}${year}`; // e.g., "12042025

  // 1) Generate a UUID, remove hyphens, convert to base-36 → ~25 chars
  const rawUuid = crypto.randomUUID().replace(/-/g, ""); // 32 hex chars
  /*  const shortId = BigInt("0x" + rawUuid)
    .toString(36)
    .toUpperCase(); // 24-25 chars */
  let hexNumber = "";
  for (let i = 0; i < rawUuid.length; i++) {
    hexNumber += String(parseInt(rawUuid[i], 16)); // Safe hex-to-decimal conversion
  }
  const shortId = parseInt(hexNumber.slice(0, 15), 10).toString(36).toUpperCase(); // Truncate to avoid overflow
  // 3. Combine date + shortId (e.g., "12042025_ABC123")
  return dateNum + rawUuid;
};

const ConfirmSelection = ({ navigation, whichCompToRender, createdTransaction, setAlertDisplay, socket }) => {
  const [customer, setCustomer] = useState({
    customerID: null,
    name: "",
    email: "",
    phoneNumber: "",
    address: "",
  });
  const [openSelectCustomer, setOpenSelectCustomer] = useState(false);
  const [operationType, setOperationType] = useState();
  const [isOperationTypeValid, setIsOperationTypeValid] = useState(false);
  const [comment, setComment] = useState("");
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false); //
  const { cartItem, total } = useSelector((state) => state.sellingCart);
  const [searchString, setSearchString] = useState("");
  const [openPaymentWindow, setOpenPaymentWindow] = useState(false);
  const { store } = useSelector((state) => state.store);
  const { user } = useSelector((state) => state.webStoreUser);
  const { queue } = useSelector((state) => state.offlineQueue);
  const dispatch = useDispatch();

  useEffect(() => {
    if (customer.name && customer.email && customer.phoneNumber && operationType && isPhoneNumberValid) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [customer, operationType]);

  const sellItem = async () => {
    let accessToken = localStorage.getItem("accessToken");
    let date = new Date().toISOString();
    let offsetDate = new Date(); /* .toISOString().split("T")[0] */

    let transactionPayload = {
      transactionDetails: {
        date: date,
        deliveryStatus: operationType.supplied ? "supplied" : "notSupplied",
        paymentMode: operationType.paymentMethod,
        numberOfItems: cartItem.length,
        totalAmount: total,
      },
      customer: {
        customerID: customer.customerID ? customer.customerID : null, // if customer is not on platform, it will be null
        fullName: customer.name,
        email: customer.email ? customer.email : " ",
        phoneNumber: customer.phoneNumber /* format phone number to become string */,
        address: customer.address,
        storePurchaseFrom: { storeName: store.storeName, storeID: store._id },
        purchaseChannel: "inStore", // or online
        totalPurchaseAmount: total,
        userType: "notOnPlatform",
        amountOwned: operationType.cash ? 0 : total - operationType.loanDetails?.initialPay,
      },
      webstoreUserID: user._id,
      store: {
        id: store._id,
        name: store.storeName,
      },
      products: cartItem.map((item, i) => {
        return {
          id: item._id,
          name: item.name,
          brand: item.brand,
          category: item.productCategory,
          productCostPrice: item.costPrice,
          soldUnitPrice: item.soldUnitPrice,
          quantity: item.soldQuantity,
          totalAmount: item.totalPrice,
          productImage: item.productImage[0],
          returned: false,
          returnedDate: null,
          supplied: operationType.supplied,
          suppliedDate: operationType.supplied ? offsetDate : null,
        };
      }),
      operationType: {
        whichOperation: operationType.cash ? "cash" : "loan",
        loanDate: operationType.cash ? null : offsetDate,
        intialPayment: operationType.cash ? null : operationType.loanDetails.initialPay,
        balance: operationType.cash ? null : total - operationType.loanDetails?.initialPay,
        dateToPay: !operationType.cash ? operationType.loanDetails.dueDate : null,
        loanDuration: !operationType.cash ? new Date(operationType.loanDetails.dueDate) - new Date() : null,
      },
      comments: comment,
      transID: generateTransactionID(),
    };
    console.log(date, "transactionPayload date");

    console.log(transactionPayload, operationType.cash, "transactionPayload");

    try {
      setIsLoading(true);
      let { UpdatedStoreProductCollection, productsAppraochingStockLimitNames, shouldSendNotification, error } = await modifyTansactionData(
        store.storeName,
        transactionPayload,
        "todayTransactions"
      );
      if (error) {
        uiAlert(error || "Transaction failed, some products in the transaction have insufficient stock", "error");
      }

      createdTransaction(transactionPayload);
      dispatch(clearCart());
      whichCompToRender("TransactionSuccess");
      setIsLoading(false);
      setAlertDisplay({
        showAlert: true,
        type: "success",
        title: "Transaction successful",
        message: "You have successfully registered a transaction",
      });
      dispatch(updateNotification(shouldSendNotification));
      console.log(productsAppraochingStockLimitNames, "productsAppraochingStockLimitNames");

      if (productsAppraochingStockLimitNames.length > 0) {
        uiAlert("Some Products are approaching stock limit,check the stock limit");
      }

      let offlineQueueItem = {
        fetchPayload: transactionPayload,
        fetchUrl: createTransactionUrl + store._id,
        fetchMethod: "POST",
        fetchAccessToken: accessToken,
        storeID: store._id,
        queueID: Math.random().toString(36).substring(2) + Date.now().toString(36), // unique id for the queue item
      };

      dispatch(addToQueue(offlineQueueItem));

      // Emit loan transaction event to socket
      transactionPayload.operationType.whichOperation === "loan" && registerReminderForLoan(transactionPayload, socket, store);
    } catch (error) {
      console.log(error);
    }

    /*   try {
      setIsLoading(true);
      let response = await fetch(createTransactionUrl + store._id, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(transactionPayload),
      });
      if (response.ok) {
        let { newTransaction, user, shouldSendNotification } = await response.json();
        dispatch(setUser(user));
        console.log(newTransaction);
        createdTransaction(newTransaction);
        newTransaction.operationType.whichOperation === "loan" && registerReminderForLoan(newTransaction, socket, store);
        dispatch(clearCart());
        whichCompToRender("TransactionSuccess");
        setIsLoading(false);
        setAlertDisplay({
          showAlert: true,
          type: "success",
          title: "Transaction successful",
          message: "You have successfully registered a transaction",
        });
        dispatch(updateNotification(shouldSendNotification));
      } else {
        setAlertDisplay({
          showAlert: true,
          type: "error",
          title: "Transaction failed",
          message: "Transaction failed, please try again",
        });
        
      }
    } catch (error) {
      console.log(error);
    } */

    /* whichCompToRender("TransactionSuccess"); */
  };

  const openPaymentWindowFunc = () => {
    setOpenPaymentWindow(true);
  };
  return (
    <>
      <div className='selectProductDivMain'>
        <div className='backArrow'>
          {" "}
          <div>
            {" "}
            <IoIosArrowBack size={20} />{" "}
            <span style={{ cursor: "pointer" }} onClick={() => whichCompToRender("FinalProductCheck")}>
              Transaction details & Customer information
            </span>{" "}
          </div>
          <div className='selectedItemsCount3338'>
            <div className='glowing-dot'></div>
            <p> {cartItem.length} Item to sell</p>
          </div>
        </div>
        <div className='updatTranshd666'>
          <div className='progressTrans'>
            <span className='circleCompleteD'>
              <FaCheck size={8} />
            </span>
            <span className='Progressbarfill rhTrans5364'></span>
            <span className='circleCompleteD'>
              <FaCheck size={8} />
            </span>
            <span className='Progressbarfill rhTrans5364'></span>
            <span className='circleOngoing'>
              <div></div>
            </span>
            <span className='Progressbarempty rhTrans5364'></span>
            <span className='circleEmpty'></span>
          </div>
        </div>
        <div className='SelectProducWrapperDiv'>
          <div>
            <OperationType
              transTotal={total}
              updateOperationType={setOperationType}
              operationTypeValid={setIsOperationTypeValid}
              currency={user.userCountryCurrencySymbol}
            />
          </div>
          <div>
            <div className='customerDetailTile'>
              <h5>Customer details</h5>
              <div className='selectCustomers'>
                <p onClick={() => setOpenSelectCustomer(true)}>
                  {" "}
                  Add <BsPersonPlusFill />
                </p>
                {openSelectCustomer && (
                  <div className='testingDrop' onClick={() => setOpenSelectCustomer(false)}>
                    <div className='dropDownCustomerDiv' onClick={(e) => e.stopPropagation()}>
                      <input
                        value={searchString}
                        onChange={(e) => setSearchString(e.target.value)}
                        className='SearchCustomer '
                        type='text'
                        placeholder='Type customer name'
                      />

                      {store.offlineCustomers.length > 0 ? (
                        store.offlineCustomers
                          .filter((cust) => cust.id.fullName.toLowerCase().includes(searchString.toLowerCase()))
                          .map((customer, i) => (
                            <EachCustomerToSelect
                              key={i}
                              customer={customer}
                              setCustomer={setCustomer}
                              closeModal={setOpenSelectCustomer}
                              setIsPhoneNumberValid={setIsPhoneNumberValid}
                            />
                          ))
                      ) : (
                        <p style={{ textAlign: "center", fontSize: "0.9rem", color: "gray" }}>No customer found</p>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className='inputCustdet'>
              <input value={customer.name} onChange={(e) => setCustomer({ ...customer, name: e.target.value })} type={"text"} required={true} />
              <p className='placeholderInputcusd'>
                Name <b style={{ color: "rgb(181, 25, 25)" }}> *</b>
              </p>
            </div>

            <div className='inputCustdet'>
              <input value={customer.email} onChange={(e) => setCustomer({ ...customer, email: e.target.value })} type={"text"} required={true} />
              <p className='placeholderInputcusd'>
                Email <b style={{ color: "rgb(181, 25, 25)" }}> *</b>
              </p>
            </div>
            <div className=' inputCustdet12 '>
              <CountryPhoneList value={customer.phoneNumber} setPhone={setCustomer} customer={customer} isPhoneNumberValidFucn={setIsPhoneNumberValid} />
            </div>
            {customer.phoneNumber && !isPhoneNumberValid && <p className='stockHighlightMesggaes2'>Phone number is not valid</p>}

            <div className='inputCustdet'>
              <input value={customer.address} onChange={(e) => setCustomer({ ...customer, address: e.target.value })} type={"text"} required={true} />
              <p className='placeholderInputcusd'>
                Address <b style={{ color: "rgb(181, 25, 25)" }}> *</b>
              </p>
            </div>

            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              name=''
              id=''
              cols='30'
              rows='6'
              maxLength={160}
              placeholder={"Add a comment if any (optional)"}
            ></textarea>
          </div>
        </div>
        <div className='totalProdSelectedDiv'>
          <div>
            <p>
              Total:{" "}
              <b>
                {user.userCountryCurrencySymbol} {total?.toLocaleString()}
              </b>
            </p>
          </div>
          <div>
            {isFormValid && isOperationTypeValid ? (
              isLoading ? (
                <button style={{ opacity: "0.6", cursor: "not-allowed" }} className='SellsButtonDef'>
                  <ButtonLoader />
                </button>
              ) : (
                <button onClick={() => openPaymentWindowFunc()} className='SellsButtonDef'>
                  Sell items
                </button>
              )
            ) : (
              <button style={{ opacity: "0.6", cursor: "not-allowed" }} className='SellsButtonDef'>
                Sell items
              </button>
            )}
          </div>
        </div>
      </div>
      {openPaymentWindow &&
        (operationType?.paymentMethod === "cash" ? (
          <CashPayment sellItems={sellItem} currency={user.userCountryCurrencySymbol} total={total} cancel={setOpenPaymentWindow} transDetail={operationType} />
        ) : operationType?.paymentMethod === "card" ? (
          <CardPayment sellItems={sellItem} currency={user.userCountryCurrencySymbol} total={total} cancel={setOpenPaymentWindow} transDetail={operationType} />
        ) : (
          <MobilePay sellItems={sellItem} currency={user.userCountryCurrencySymbol} total={total} cancel={setOpenPaymentWindow} transDetail={operationType} />
        ))}
    </>
  );
};

export default ConfirmSelection;

const EachCustomerToSelect = ({ customer, setCustomer, closeModal, setIsPhoneNumberValid }) => {
  return (
    <>
      <div
        className='eachCustomerTOSleect'
        onClick={() => {
          setCustomer({
            customerID: customer.customerID,
            name: customer.fullName,
            email: customer.email,
            phoneNumber: customer.phoneNumber,
            address: customer.address,
          });
          closeModal(false);
          setIsPhoneNumberValid(true);
        }}
      >
        <div className='customerSlectImage'>
          <img src={customer.avartar} />
        </div>
        <div>
          <p className='customerName123'>{customer.fullName}</p>
          <p>{customer.address}</p>
        </div>
      </div>
    </>
  );
};

// this function must not be deletd
export const registerReminderForLoan = (transaction, socket, store) => {
  console.log("registering reminder for loan");
  socket.emit("newLoanTransaction", { room: store._id, loanData: transaction });
};
